import LogDataActionModel from "@/common/models/Logs/LogDataActionModel";

export default class LogActionModel {

    nextPageToken: string| undefined;
    entries : Array<LogDataActionModel>  = [];
}